import { Parallax, ParallaxProvider } from "react-scroll-parallax";

function HeroSection() {

  const scrollToNext = () => {
    window.scrollTo({
      top: 300,
      behavior: "smooth",
    });
  };

  return (
    <ParallaxProvider>
      <Parallax speed={-25}>
        <section className="relative flex items-end text-white bg-black h-full min-h-screen">
          <video
            className="absolute top-0 left-0 w-full h-full object-cover"
            loop
            autoPlay
            muted
            playsInline
          >
            <source src="/video/presentationSite.mp4" type="video/mp4" />
          </video>

          <div className="relative z-10 container text-left">
            <div className="flex flex-col">
              <div className="flex flex-col lg:flex-row items-start lg:items-end gap-4">
                <p className="text-[30px] sm:text-7xl text-[#ad3500]">Les Clés Conciergerie</p>
              </div>
              <div className="flex justify-start items-start gap-2 md:gap-4">
                <p className="text-[15px] sm:text-xl text-[#ad3500] justify-center max-w-md">
                  Confiez nous vos clés, on s'occupe du reste.
                </p>
              </div>
              <div
                onClick={scrollToNext}
                aria-label="scroll to next section"
                className="flex justify-center items-start transition duration-300 ease-in-out">
                <img src="/images/Icon/arrow-down.svg" alt="Images" height={50} width={50}/>
              </div>
            </div>
          </div>
        </section>
      </Parallax>
    </ParallaxProvider>
  );
}

export default HeroSection;
